import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";

import firebase from "firebase/compat/app";

import "firebase/compat/firestore";
import "firebase/firestore";
import Home from "./Components/Home";
import { BrowserRouter } from "react-router-dom";

const firebaseConfig = {
  apiKey: "AIzaSyDfc61jiY1drDBgNbZJlLQF6r_LKsC7DCs",
  authDomain: "ewallet-aly.firebaseapp.com",
  databaseURL: "https://ewallet-aly.firebaseio.com",
  projectId: "ewallet-aly",
  storageBucket: "ewallet-aly.appspot.com",
  messagingSenderId: "706500748543",
  appId: "1:706500748543:web:007eb1b33164c858c4d8ca",
  measurementId: "G-L28E0E47LJ",
};

// firebase.initializeApp(firebaseConfig);

// Initialize Firebase
export const myFbApp = firebase.initializeApp(firebaseConfig);
export const firestore = firebase.firestore();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Home />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
